import { useMemo } from "react";
import { useGeocodingCore } from "@mapbox/search-js-react";

//#region src/services/use-location-service.ts
const useLocationService = (accessToken, logService) => {
	const geocoding = useGeocodingCore({ accessToken });
	return useMemo(() => ({
		getLocationsByAddress: async (address, requireFullAddress) => {
			let response;
			try {
				response = await geocoding.forward(address.trim(), {
					country: "us",
					...requireFullAddress ? { types: new Set(["address", "secondary_address"]) } : {}
				});
			} catch (error) {
				logService.logUnknownError({ source: "LocationService" }, error);
				return { error };
			}
			return { locations: response.features.map(featureToGeoLocation) };
		},
		getLocationsByCoordinates: async (geolocation) => {
			let response;
			try {
				response = await geocoding.reverse({
					lat: geolocation.latitude,
					lon: geolocation.longitude
				});
			} catch (error) {
				logService.logUnknownError({ source: "LocationService" }, error);
				return { error };
			}
			return { locations: response.features.map(featureToGeoLocation) };
		}
	}), [geocoding, logService]);
};
function featureToGeoLocation(feature) {
	const { properties, geometry } = feature;
	const { address, place, region, postcode, country } = properties.context;
	return {
		name: properties.full_address,
		longitude: geometry.coordinates[0],
		latitude: geometry.coordinates[1],
		address: {
			line1: address?.name,
			city: place?.name,
			state: region?.name,
			zip: postcode?.name,
			country: country?.name
		}
	};
}

//#endregion
export { useLocationService };